import {refreshState, saveState} from 'interactors/statePersistence';
import {updateWidget} from 'ui/adapters/Device';
import {defaultSettings, RewriteStateSettings} from './settings';

export function rewriteState(
  state: CoreState,
  settings: RewriteStateSettings = defaultSettings
): void {
  const {refresh} = settings;
  const updateState = refresh ? refreshState : saveState;

  updateState(state);
  updateWidget(state);
}
